import Observable from './observable';
export default function map(iteratee, stream) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        let index = -1;
        // tslint:disable-next-line:ter-prefer-arrow-callback
        const subscription = stream.subscribe({
            next(value) {
                // tslint:disable-next-line:no-increment-decrement no-param-reassign
                const mappedValue = iteratee(value, ++index);
                observer.next(mappedValue);
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                observer.complete();
            },
        });
        return function unsubscribe() {
            subscription.unsubscribe();
        };
    });
}
//# sourceMappingURL=map.js.map